import PhoneField from './component';
import { PhoneFieldProps } from './types';

export type { PhoneFieldProps };
export default PhoneField;
